// removed by extract-text-webpack-plugin
module.exports = {"phoneButton":"_2aqRL4NdJbMDyRmG-SChJO","revealed":"_1HkBjDwGW_bbAVK0RazH_I","icon":"A18vWk2rOgeo926R1-TQQ","iconsIndent":"_1hEv57bM5USSzEfrVccO-4","message":"_3N-VBRHke08tuWPLeYaWbA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/PhoneButton/PhoneButton.scss
// module id = 1716
// module chunks = 0